import StandardGateway from './lib/standard_gateway';

export default class ComplianceEventsHttpGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/compliance/events');
  }

  fetchAll(params) {
    let url = `${this.endpoint.set(params).fetchAllUrl}`;
    let resource = this.endpoint.patterns.fetchAllUrl;

    return this.http
      .get(url, params, resource)
      .then(dto => {
        this.observer.onFetchSuccess(dto, params);
        return dto;
      })
      .catch(error => {
        this.observer.onFetchError(error, params);
        throw error;
      });
  }
}
